module.exports = __webpack_public_path__ + "static/phone-farmer-99c2a4158340a9388e07f804b25971f2.png";